module.exports = "<app-quotation [type]=\"'quotation'\"></app-quotation>"